import * as React from 'react'
import { Modal } from './Modal'
import { TwButton } from '../Button/TwButton'

export { Modal }

interface AlertDialogProps {
  isOpen: boolean
  onClose: (value: boolean) => void
  title: string
  content: string
  okLabel: string
  abortLabel?: string
}

/** Simple promise-style alert/confirm dialog driven by ModalStore. */
export const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen,
  onClose,
  title,
  content,
  okLabel,
  abortLabel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={() => onClose(false)}
    labelledBy="alert-dialog-title"
    panelClassName="sm:max-w-sm"
  >
    <div className="p-5">
      <h3 id="alert-dialog-title" className="text-base font-semibold text-gray-900">
        {title}
      </h3>
      <p className="mt-2 text-sm text-gray-500">{content}</p>
      <div className="mt-5 flex justify-end gap-2">
        {abortLabel && (
          <TwButton variant="outline" onClick={() => onClose(false)}>
            {abortLabel}
          </TwButton>
        )}
        <TwButton variant="solid" autoFocus onClick={() => onClose(true)}>
          {okLabel}
        </TwButton>
      </div>
    </div>
  </Modal>
)
